import { render, staticRenderFns } from "./DashboardTour.vue?vue&type=template&id=f7e280ac&scoped=true"
import script from "./DashboardTour.vue?vue&type=script&lang=js"
export * from "./DashboardTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e280ac",
  null
  
)

export default component.exports